module.exports = __webpack_public_path__ + "images/inside-tab.svg";